
/* ============ silk (flow field, green + amber, combed trails + cursor whirlpool) ============ */
const canvas = document.getElementById("hero-anim");
const ctx = canvas.getContext("2d");
let W, H, dpr;
const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;
const parts = [];
function fitParts() {                                   /* density scales with area */
  const target = reduced ? 0 : Math.min(3800, Math.round(W * H / 380));
  while (parts.length < target) parts.push({ x: Math.random() * W, y: Math.random() * H, life: 80 + Math.random() * 320 });
  parts.length = target;
}
function resize() {
  dpr = Math.min(devicePixelRatio || 1, 2);
  W = canvas.clientWidth; H = canvas.clientHeight;
  canvas.width = W * dpr; canvas.height = H * dpr;
  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  ctx.fillStyle = "#070d09"; ctx.fillRect(0, 0, W, H);
  ctx.lineWidth = 0.7; ctx.lineCap = "round";
  fitParts();
}
resize(); addEventListener("resize", resize);

const mouse = { x: -9999, y: -9999 };
let mvx = 0, mvy = 0;                                   /* smoothed cursor velocity → comb */
canvas.parentElement.addEventListener("pointermove", e => {
  const r = canvas.getBoundingClientRect();
  const nx = e.clientX - r.left, ny = e.clientY - r.top;
  if (mouse.x > -9000) { mvx = mvx * 0.7 + (nx - mouse.x) * 0.3; mvy = mvy * 0.7 + (ny - mouse.y) * 0.3; }
  mouse.x = nx; mouse.y = ny;
});
canvas.parentElement.addEventListener("pointerleave", () => { mouse.x = -9999; mouse.y = -9999; mvx = 0; mvy = 0; });

/* compact perlin-ish noise */
function makeNoise() {
  const p = [...Array(256).keys()];
  for (let i = 255; i > 0; i--) { const j = (Math.random() * (i + 1)) | 0; [p[i], p[j]] = [p[j], p[i]]; }
  const perm = new Uint8Array(512); for (let i = 0; i < 512; i++) perm[i] = p[i & 255];
  const fade = t => t * t * t * (t * (t * 6 - 15) + 10), lerp = (a, b, t) => a + (b - a) * t;
  const grad = (h, x, y) => ((h & 1) ? x : -x) + ((h & 2) ? y : -y);
  return (x, y) => {
    const X = Math.floor(x) & 255, Y = Math.floor(y) & 255; x -= Math.floor(x); y -= Math.floor(y);
    const u = fade(x), v = fade(y), a = perm[X] + Y, b = perm[X + 1] + Y;
    return lerp(lerp(grad(perm[a], x, y), grad(perm[b], x - 1, y), u), lerp(grad(perm[a + 1], x, y - 1), grad(perm[b + 1], x - 1, y - 1), u), v);
  };
}
const flow = makeNoise(), tint = makeNoise();   /* separate field drives the colour */
const C1 = [99, 242, 162];   /* green */
const C2 = [255, 180, 84];   /* amber */
const R2 = 92000;            /* whirlpool radius ≈ 303px */
const RC2 = 32000;           /* comb radius ≈ 179px — only nearby fibres follow the cursor */
let tFlow = 0;
function frame() {
  ctx.fillStyle = "rgba(7,13,9,0.024)"; ctx.fillRect(0, 0, W, H);   /* very slow fade → long silk trails */
  tFlow += 0.0007; mvx *= 0.92; mvy *= 0.92;
  const mspeed = Math.min(1, (Math.abs(mvx) + Math.abs(mvy)) * 0.055);
  for (const p of parts) {
    const a = flow(p.x * 0.0012, p.y * 0.0012 + tFlow) * Math.PI * 4;
    let vx = Math.cos(a), vy = Math.sin(a), bright = 0;
    const dx = p.x - mouse.x, dy = p.y - mouse.y, d2 = dx * dx + dy * dy;
    if (d2 < R2) {
      const f = 1 - d2 / R2, fw = f * f, d = Math.sqrt(d2) + 0.001;
      vx += (-dy / d * 3.1 - dx / d * 0.75) * fw;      /* whirlpool: strong orbit with inward pull */
      vy += ( dx / d * 3.1 - dy / d * 0.75) * fw;
      if (d2 < RC2) { const c = 1 - d2 / RC2; vx += mvx * c * c * 1.1; vy += mvy * c * c * 1.1; }   /* comb only close fibres */
      bright = f * (0.35 + mspeed * 0.65);
    }
    const px = p.x, py = p.y;
    p.x += vx * 0.9; p.y += vy * 0.9;
    let m = (tint(p.x * 0.0011 + 140, p.y * 0.0011 - tFlow * 0.6) + 1) * 0.5; m = m * m * (3 - 2 * m);
    let r = C1[0] + (C2[0] - C1[0]) * m, g = C1[1] + (C2[1] - C1[1]) * m, b = C1[2] + (C2[2] - C1[2]) * m;
    r += (255 - r) * bright; g += (255 - g) * bright; b += (255 - b) * bright;
    ctx.strokeStyle = `rgba(${r | 0},${g | 0},${b | 0},${0.34 + bright * 0.55})`;
    ctx.beginPath(); ctx.moveTo(px, py); ctx.lineTo(p.x, p.y); ctx.stroke();
    if (--p.life < 0 || p.x < -5 || p.x > W + 5 || p.y < -5 || p.y > H + 5) { p.x = Math.random() * W; p.y = Math.random() * H; p.life = 80 + Math.random() * 320; }
  }
  requestAnimationFrame(frame);
}
if (!reduced) frame();

/* ============ content ============ */
const [about, research, pubs, talks, media, awards, roles] = await Promise.all(
  ["about", "research", "publications", "talks", "media", "awards", "roles"].map(f => fetch(`data/${f}.json`).then(r => r.json()))
);
const fmt = d => new Date(d).toLocaleDateString("en-GB", { month: "short", year: "numeric" });
/* data files use absolute /images/... paths; serve them relative so the site works under any base path */
const rel = p => typeof p === "string" ? p.replace(/^\//, "") : p;

/* keep hero stats in sync with the data */
document.getElementById("stat-pubs").dataset.count = pubs.publications.length;
document.getElementById("stat-talks").dataset.count = talks.talks.length;
document.getElementById("stat-grants").dataset.count = awards.awards.filter(a => a.status !== "submitted").length;

document.getElementById("headshot").src = rel(about.headshot ?? "/images/profile.jpg");
document.getElementById("p-name").textContent = about.name;
document.getElementById("p-title").textContent = about.title;
document.getElementById("p-affil").textContent = about.affiliation;
document.getElementById("bio-lede").innerHTML = about.bio[0]
  .replace("AI-enabled tools", "<em>AI-enabled tools</em>")
  .replace("inform conservation action", "<em>inform conservation action</em>")
  .replace("responsibly and ethically", "<em>responsibly and ethically</em>");
document.getElementById("bio-rest").innerHTML = about.bio.slice(1).map(p => `<p>${p}</p>`).join("");
document.getElementById("education").innerHTML = about.education.map(e => `
  <div class="edu"><div class="d">${e.degree}</div><div class="m">${e.institution} · ${e.year}</div></div>`).join("");
const linkNames = { researchgate: "ResearchGate", linkedin: "LinkedIn", scholar: "Google Scholar", department: "Cambridge Zoology" };
document.getElementById("links").innerHTML = Object.entries(about.links).map(([k, v]) =>
  `<a href="${v}" target="_blank" rel="noopener">${linkNames[k] ?? k} ↗</a>`).join("");

document.getElementById("res-grid").innerHTML = research.researchTopics.map((t, i) => `
  <div class="res-card reveal">
    <span class="num">Topic ${i + 1} · ${t.relatedPublications?.length ?? 0} related publications</span>
    <h3>${t.name}</h3><p>${t.description}</p>
  </div>`).join("");

const pubUrl = p => p.url ?? (p.doi ? `https://doi.org/${p.doi}` : "");
const sorted = [...pubs.publications].sort((a, b) => b.year - a.year || (b.date > a.date ? 1 : -1));
document.getElementById("pub-rows").innerHTML = sorted.map((p, i) => `
  <div class="pub-row reveal" data-i="${i}">
    <div class="head">
      <span class="thumb">${p.image ? `<img src="${rel(p.image)}" alt="" loading="lazy">` : ""}</span>
      <span class="y">${p.year}</span>
      <span class="t">${p.title}</span>
      <span class="j">${p.journal ?? ""}</span>
      <span class="x">+</span>
    </div>
    <div class="body"><div class="body-inner">
      ${p.image ? `<a class="cover" href="${pubUrl(p)}" target="_blank" rel="noopener"><img src="${rel(p.image)}" alt="${p.title}" loading="lazy"></a>` : `<span></span>`}
      <div>
        <p class="authors">${p.authors.map(a => a.isSamReynolds ? `<b>${a.name}</b>` : a.name).join(" · ")}</p>
        <p class="abstract">${(p.abstract ?? "").slice(0, 420)}${(p.abstract ?? "").length > 420 ? "…" : ""}</p>
        ${pubUrl(p) ? `<a class="go" href="${pubUrl(p)}" target="_blank" rel="noopener">Read the paper ↗</a>` : ""}
      </div>
    </div></div>
  </div>`).join("");
document.getElementById("pub-rows").addEventListener("click", e => {
  if (e.target.closest("a")) return;
  const row = e.target.closest(".pub-row"); if (!row) return;
  const body = row.querySelector(".body");
  const open = row.classList.toggle("open");
  body.style.maxHeight = open ? body.scrollHeight + "px" : "0";
});

/* grants & awards */
document.getElementById("awards-grid").innerHTML = [...awards.awards]
  .sort((a, b) => b.year - a.year)
  .map(a => `
    <div class="award reveal ${a.status === "submitted" ? "submitted" : ""}">
      <div class="top">
        <span class="yr">${a.year}</span>
        ${a.amount ? `<span class="amt">${a.amount}</span>` : ""}
      </div>
      <h4>${a.title}</h4>
      ${a.funder ? `<span class="funder">${a.funder}</span>` : ""}
      <p>${a.description}</p>
      ${a.status === "submitted" ? `<span class="flag">Under review</span>` : ""}
    </div>`).join("");

/* roles & service */
document.getElementById("roles-grid").innerHTML = roles.roles.map(r => `
  <div class="role-item reveal">
    <span class="period">${r.period}</span>
    <div><h4>${r.title}</h4>${r.detail ? `<div class="detail">${r.detail}</div>` : ""}</div>
  </div>`).join("");

/* talks: featured + scrollable timeline + ticker */
const KEY_TALKS = [
  "world-biodiversity-forum-2026",
  "defra-evidence-community-conference-2026",
  "houses-of-parliament-2026",
  "aslo-sil-2026",
];
const talksSorted = [...talks.talks].sort((a, b) => (b.date > a.date ? 1 : -1));
document.getElementById("key-talks").innerHTML = talksSorted
  .filter(t => KEY_TALKS.includes(t.id))
  .map(t => `
    <div class="key-talk">
      <span class="d">${fmt(t.date)}</span>
      <h4>${t.title}</h4>
      <span class="v">${t.venue}</span>
    </div>`).join("");
document.getElementById("talk-count").textContent = `${talksSorted.length} since 2025`;
document.getElementById("timeline").innerHTML = talksSorted.map(t => `
  <div class="tl-item">
    <span class="d">${fmt(t.date)}</span>
    <h4>${t.title}</h4>
    <div class="v">${t.venue}</div>
  </div>`).join("");
const tickerContent = talksSorted.map(t => `<span><b>${fmt(t.date)}</b> — ${t.title}, ${t.venue}</span>`).join("");
document.getElementById("ticker").innerHTML = tickerContent + tickerContent;

document.getElementById("media-grid").innerHTML = media.media.map(m => {
  const playable = ["video", "podcast", "panel"].includes(m.type);
  return `
  <a class="m-card reveal" href="${m.link ?? "#"}" target="_blank" rel="noopener">
    <div class="media-thumb">
      <span class="tp">${m.type}</span>
      ${m.image ? `<img src="${rel(m.image)}" alt="${m.title}" loading="lazy">` : ""}
      ${playable ? `<span class="play"><svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg></span>` : ""}
    </div>
    <div class="m-body">
      <h4>${m.title}</h4>
      <span class="mt">${m.venue} · ${fmt(m.date)}</span>
    </div>
  </a>`;
}).join("");

/* notes — latest three; the section stays quiet if notes.json is missing */
let notes = [];
try {
  ({ notes } = await (await fetch("data/notes.json")).json());
  document.getElementById("notes-list").innerHTML = notes.slice(0, 3).map(n => `
    <div class="note-row reveal">
      <span class="d">${new Date(n.date + "T00:00:00").toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })}</span>
      <div>
        <h3><a href="notes.html#${n.slug}">${n.title}</a></h3>
        ${n.excerpt ? `<p class="ex">${n.excerpt}</p>` : ""}
      </div>
    </div>`).join("");
} catch { document.getElementById("notes").style.display = "none"; }

/* latest — newest video (with an embedUrl) + newest note, in the hero */
{
  const dayFmt = d => new Date(d + "T00:00:00").toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
  const video = [...media.media].filter(m => m.embedUrl).sort((a, b) => (b.date > a.date ? 1 : -1))[0];
  const note = notes[0];
  const panel = document.getElementById("latest");
  const videoBox = document.getElementById("latest-video");
  /* YouTube loads only when play is pressed, from the no-cookie domain */
  function bindPlay() {
    const btn = videoBox.querySelector(".latest-play");
    btn?.addEventListener("click", () => {
      const embed = video.embedUrl.replace("www.youtube.com", "www.youtube-nocookie.com");
      btn.outerHTML = `<iframe src="${embed}?autoplay=1&rel=0&playsinline=1" title="${video.title}" allow="autoplay; encrypted-media; picture-in-picture; fullscreen"></iframe>`;
    });
  }
  if (video || note) {
    const newest = [video?.date, note?.date].filter(Boolean).sort().pop();
    document.getElementById("latest-updated").textContent = `Updated ${dayFmt(newest)}`;

    if (video) {
      videoBox.className = "latest-video";
      videoBox.innerHTML = `
        <div class="latest-frame">
          <button class="latest-play" type="button" aria-label="Play video: ${video.title}">
            ${video.image ? `<img src="${rel(video.image)}" alt="">` : ""}
            <span class="pb"></span>
          </button>
        </div>
        <span class="latest-kind"><b>Video</b> · ${video.venue} · ${dayFmt(video.date)}</span>
        <span class="latest-title">${video.title}</span>`;
      videoBox.dataset.thumb = videoBox.querySelector(".latest-frame").innerHTML;
      bindPlay();
    } else {
      videoBox.nextElementSibling.remove();
      videoBox.remove();
    }

    const noteLink = document.getElementById("latest-note");
    if (note) {
      const img = note.html?.match(/<img[^>]+src="([^"]+)"/)?.[1];
      noteLink.href = `notes.html#${note.slug}`;
      noteLink.innerHTML = `
        ${img ? `<img src="${rel(img)}" alt="" loading="lazy">` : ""}
        <div>
          <span class="latest-kind"><b>Note</b> · ${dayFmt(note.date)}</span>
          <div class="latest-title">${note.title}</div>
          ${note.excerpt ? `<div class="ex">${note.excerpt}</div>` : ""}
        </div>`;
    } else {
      noteLink.previousElementSibling.remove();
      noteLink.remove();
    }

    panel.hidden = false;
    document.querySelector(".hero-inner").classList.add("has-latest");

    /* mobile: pill at the bottom of the hero opens the panel as a bottom sheet */
    const pill = document.getElementById("latest-pill"), scrim = document.getElementById("latest-scrim");
    const first = video ?? note;
    const pillImg = video?.image ? rel(video.image) : null;
    document.getElementById("latest-pill-row").innerHTML =
      `${pillImg ? `<img src="${pillImg}" alt="">` : ""}<span>${first.title}${video && note ? " · and a new note" : ""}</span>`;
    /* the pill goes away once it's been opened or scrolled past, and stays away until something newer is posted */
    const mobile = matchMedia("(max-width: 960px)");
    const seenKey = [video?.id, note?.slug].join("|");
    let seen = false;
    try { seen = localStorage.getItem("latest-seen") === seenKey; } catch {}
    const dismissPill = () => {
      if (pill.classList.contains("gone")) return;
      pill.classList.add("gone");
      try { localStorage.setItem("latest-seen", seenKey); } catch {}
    };
    pill.hidden = seen;
    if (!seen) {
      const heroObs = new IntersectionObserver(([e]) => {
        if (!e.isIntersecting && mobile.matches) { dismissPill(); heroObs.disconnect(); }
      });
      heroObs.observe(document.querySelector(".hero"));
    }
    const setOpen = open => {
      panel.classList.toggle("open", open);
      scrim.classList.toggle("open", open);
      pill.setAttribute("aria-expanded", open);
      document.body.style.overflow = open ? "hidden" : "";
      if (open) document.getElementById("latest-close").focus();
      else {
        /* closing stops a playing video by putting the thumbnail back */
        if (video && panel.querySelector(".latest-frame iframe")) {
          videoBox.querySelector(".latest-frame").innerHTML = videoBox.dataset.thumb;
          bindPlay();
        }
        dismissPill();
      }
    };
    pill.addEventListener("click", () => setOpen(true));
    scrim.addEventListener("click", () => setOpen(false));
    document.getElementById("latest-close").addEventListener("click", () => setOpen(false));
    addEventListener("keydown", e => { if (e.key === "Escape" && panel.classList.contains("open")) setOpen(false); });
    /* leaving the mobile layout with the sheet open shouldn't leave the page scroll-locked */
    mobile.addEventListener("change", e => { if (!e.matches && panel.classList.contains("open")) setOpen(false); });
  }
}

/* reveals */
const io = new IntersectionObserver(es => {
  for (const e of es) if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
}, { threshold: 0.1 });
document.querySelectorAll(".reveal").forEach(el => io.observe(el));

/* count-up stats */
const cio = new IntersectionObserver(es => {
  for (const e of es) {
    if (!e.isIntersecting) continue;
    cio.unobserve(e.target);
    const el = e.target, target = +el.dataset.count, t0 = performance.now();
    (function tick(t) {
      const p = Math.min(1, (t - t0) / 1400), ease = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * ease);
      if (p < 1) requestAnimationFrame(tick);
    })(t0);
  }
}, { threshold: 0.6 });
document.querySelectorAll("[data-count]").forEach(el => cio.observe(el));
setTimeout(() => document.querySelectorAll("[data-count]").forEach(el => {
  if (el.textContent === "0") el.textContent = el.dataset.count;
}), 4000);

/* gentle parallax on band */
const bands = [...document.querySelectorAll(".band video")];
addEventListener("scroll", () => {
  for (const v of bands) {
    const r = v.parentElement.getBoundingClientRect();
    if (r.bottom > 0 && r.top < innerHeight) {
      const p = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
      v.style.transform = `translateY(${p * -28}px)`;
    }
  }
}, { passive: true });
